/* Adsvedia front end. No framework, no CDN dependency.
   The compare slider lives in compare.js. */
(function(){
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia && window.matchMedia('(max-width: 700px)').matches;

  /* ---- every video on this page is silent, always.
     Visitors are here to see the work, not to be shouted at by an
     autoplaying soundtrack. Belt and braces: the markup is muted, and
     we mute again here in case a browser restores state on back/forward. */
  var allVids = [].slice.call(document.querySelectorAll('video'));
  function silence(v){
    v.muted = true;
    v.defaultMuted = true;
    v.volume = 0;
    v.removeAttribute('controls');
    v.controls = false;
  }
  allVids.forEach(function(v){
    silence(v);
    /* if anything ever unmutes it, put it back */
    v.addEventListener('volumechange', function(){ if(!v.muted){ silence(v); } });
  });

  var heroVids = [].slice.call(document.querySelectorAll('.stage3 video'));

  /* ---- tap a phone to start it.
     Needed because muted autoplay is refused in several common cases:
     iOS Low Power Mode, data saver, and in-app browsers like Instagram. ---- */
  [].slice.call(document.querySelectorAll('.stage3 .ph')).forEach(function(ph){
    var v = ph.querySelector('video');
    var b = ph.querySelector('.ph-play');
    if(!v || !b) return;
    b.addEventListener('click', function(){
      silence(v);
      var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
    });
    v.addEventListener('play',  function(){ b.style.display = 'none'; });
    v.addEventListener('pause', function(){ b.style.display = 'grid'; });
  });

  /* ---- ambient autoplay when the stage is in view.
     On phones only the centre video streams, so we are not pulling ~40MB
     over cell data before anyone has asked for it. ---- */
  if(heroVids.length && 'IntersectionObserver' in window){
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if(e.isIntersecting){
          if(v.paused){ var p = v.play(); if(p && p.catch){ p.catch(function(){}); } }
        } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    heroVids.forEach(function(v){
      if(narrow && v.id !== 'heroVideo') return;
      vio.observe(v);
    });
  }

  /* ---- scroll dolly on the phone stage ---- */
  var stage = document.querySelector('.stage3');
  if(stage && !reduced){
    var ticking = false;
    var dolly = function(){
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var t = Math.min(y, 700);
      stage.style.transform = 'translateY(' + (-t * 0.055) + 'px) scale(' + (1 - t * 0.00013) + ')';
      ticking = false;
    };
    window.addEventListener('scroll', function(){
      if(!ticking){ ticking = true; window.requestAnimationFrame(dolly); }
    }, { passive: true });
    dolly();
  }

  /* ---- sample rail: tap to play, one at a time, silent ---- */
  var cards = [].slice.call(document.querySelectorAll('#rack .card'));
  var railVids = [];
  cards.forEach(function(card){
    var v = card.querySelector('video'), b = card.querySelector('.card-play');
    if(!v || !b) return;
    railVids.push(v);
    b.addEventListener('click', function(){
      railVids.forEach(function(o){ if(o !== v){ o.pause(); } });
      document.querySelectorAll('.card-play').forEach(function(btn){ if(btn !== b){ btn.style.display = 'grid'; } });
      silence(v);
      var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
    });
    v.addEventListener('play',  function(){ b.style.display = 'none'; });
    v.addEventListener('pause', function(){ b.style.display = 'grid'; });
    v.addEventListener('ended', function(){ b.style.display = 'grid'; });
  });

  /* ---- trade filter tabs ---- */
  var tabs = [].slice.call(document.querySelectorAll('.tab'));
  if(tabs.length){
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var want = tab.getAttribute('data-trade');
        tabs.forEach(function(t){ t.setAttribute('aria-pressed', String(t === tab)); });
        cards.forEach(function(card){
          var trade = card.getAttribute('data-trade') || '';
          var show = (want === 'all') || (trade.toLowerCase() === want.toLowerCase());
          card.hidden = !show;
          if(!show){ var v = card.querySelector('video'); if(v){ v.pause(); } }
        });
      });
    });
  }

  /* ---- scroll reveal ---- */
  if(reduced || !('IntersectionObserver' in window)) return;
  var groups = ['.hero .wrap','.sec-head','.cards .gcard','.compare-wrap','.rack .card','.steps .step','.cost-grid > div','.form-panel'];
  var targets = [];
  groups.forEach(function(sel){
    var nodes = document.querySelectorAll(sel);
    nodes.forEach(function(el, i){
      el.classList.add('reveal');
      if(nodes.length > 1){ el.style.transitionDelay = Math.min(i * 70, 280) + 'ms'; }
      targets.push(el);
    });
  });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
  targets.forEach(function(el){ io.observe(el); });
  requestAnimationFrame(function(){
    targets.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < window.innerHeight && r.bottom > 0){ el.classList.add('is-in'); io.unobserve(el); }
    });
  });
})();
